import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import {DmessagePqForm} from "@/form/DeviceMessageForm";
import Paging from "biz-ts/src/api/Paging";
import DeviceMessage from "@/model/DeviceMessage";

@Singleton
export default abstract class DeviceMessageApi {
    abstract paging(form: DmessagePqForm): Promise<Paging<DeviceMessage>>
}

class DeviceMessageApiImpl extends BaseApi implements DeviceMessageApi {

    protected urlPrefix = 'device/message'

    paging(form: DmessagePqForm): Promise<Paging<DeviceMessage>> {
        return this.axios.post('paging', form)
    }
}

Container.bind(DeviceMessageApi).to(DeviceMessageApiImpl)
